import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { TranslateService, TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import {SupportedLanguages} from '../../../modules/global';
import { MatMenuTrigger, MatMenu } from '@angular/material/menu';
import { MatTooltip } from '@angular/material/tooltip';
import { SvgIconComponent } from 'angular-svg-icon';
import { MatRipple } from '@angular/material/core';
import { NgFor } from '@angular/common';

@Component({
    selector: 'slm-language-selector',
    templateUrl: './language-selector.component.html',
    imports: [MatMenuTrigger, MatTooltip, SvgIconComponent, MatRipple, MatMenu, NgFor, TranslateDirective, TranslatePipe]
})
export class LanguageSelectorComponent implements OnInit {
  private readonly translate = inject(TranslateService);

  public readonly languages = this.translate.getLangs().map((language) => ({
    label: `LBL_LANGUAGE.${language.toUpperCase()}`,
    value: language as SupportedLanguages
  }));

  @Input() public language: SupportedLanguages = 'hu';
  @Output() public selected = new EventEmitter<SupportedLanguages>();

  public ngOnInit() {
    this.language = this.translate.currentLang as SupportedLanguages;
  }

  public selectLanguage(language: SupportedLanguages) {
    if (language !== this.language) {
      this.language = language;
      this.selected.emit(language);
      this.translate.use(language);
    }
  }
}
